<div class="min-vh-80 d-flex flex-column align-items-center justify-content-center" id="principal"
    [ngStyle]="{'background': 'url(' + backgroundUrl + ') no-repeat 0 0 / cover'}" style="padding-bottom: 20px;">
    <div class="row mt-5">
        <img [src]="logoImagen" width="25%" alt="Universales">
    </div>
    <div class="row">
        <img [src]="logo" width="50%" alt="Guatemaltecos Ilustres">
    </div>
    <div class="row">
        <h5 class="tituloEdicion">{{edicion}}</h5>
        <span class="subTitulo" *ngIf="finalista">Etapa final</span>
    </div>
    <div *ngIf="mostrarContador" class="timer w-100 m-auto text-center" style="padding-left: 0px; padding-right: 0px;"
        id="timer">
        <ctimer [finaliza]="fechaFinalista"></ctimer>
    </div>
    <div *ngIf="nominarVotar" class="w-100 m-auto text-center" style="padding-left: 0px; padding-right: 0px;">
        <a class="btn btn1" href="#/nominar">Nominar</a>
        <a class="btn btn2" href="#/categoria">Votar</a>
    </div>
</div>
<div *ngIf="mostrarCategorias" class="w-100">
    <categorias-info></categorias-info>
</div>
<div *ngIf="nuevasNominaciones" class="w-100 separador">
    <nominacion-carrusel titulo="Nuevas Nominaciones"></nominacion-carrusel>
</div>
<div *ngIf="masVotado" class="w-100 separador">
    <nominacion-carrusel tipoConsulta="masVotados" titulo="Más Votados" campoFiltro="votos"
        [filtroAscendente]="true"></nominacion-carrusel>
</div>
<div *ngIf="finalista" class="w-100">
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Finalistas categoría Social" [categoriaId]="1"
            [finalista]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Finalistas categoría Deporte" [categoriaId]="2"
            [finalista]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Finalistas categoría Ciencia" [categoriaId]="3"
            [finalista]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Finalistas categoría Empresarial" [categoriaId]="4"
            [finalista]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Finalistas categoría Arte" [categoriaId]="5"
            [finalista]="true"></nominacion-carrusel>
    </div>
</div>
<div *ngIf="ganadores" class="w-100">
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Ganador categoría Social" [categoriaId]="1" [ganador]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Ganador categoría Deporte" [categoriaId]="2"
            [ganador]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Ganador categoría Ciencia" [categoriaId]="3"
            [ganador]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Ganador categoría Empresarial" [categoriaId]="4"
            [ganador]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Ganador categoría Arte" [categoriaId]="5" [ganador]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Elegido por el público" [categoriaId]="6" [ganador]="true"></nominacion-carrusel>
    </div>
    <div class="w-100 separador">
        <nominacion-carrusel titulo="Orator" [categoriaId]="7" [ganador]="true"></nominacion-carrusel>
    </div>
</div>